import React from 'react';
import Modal, { ModalWidths } from '../Modal';
import Confirmation from './Confirmation';
import Failure from './Failure';
import Success from './Success';
import Upgrading from './Upgrading';
import Introduction from './Introduction';
import MigrationMap from './MigrationMap';
import introHeader from './icons/assets/intro-header.png';
import { DataModelV2UpgradeModalProps } from './types';

export type { DataModelV2UpgradeModalProps, UpgradeState, UpgradeStep } from './types';

const titles = {
  intro: 'A major upgrade to your TokenTax account',
  ready: 'Before we upgrade your account',
  upgrading: 'Migrating your account',
  success: 'Your account is upgraded',
  failure: 'We couldn’t complete your upgrade',
};

export default function DataModelV2UpgradeModal({
  state,
  isOpen = true,
  onClose,
  ...actions
}: DataModelV2UpgradeModalProps) {
  const title = titles[state.status];
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      showCloseIcon={false}
      title={title}
      headerClassName="sr-only"
      titlePadding="p-0"
      padded={false}
      width={ModalWidths.XL2}
      className="overflow-hidden !rounded-xl border border-base"
    >
      {state.status === 'intro' ? (
        <img src={introHeader} alt="" width={600} height={300} className="block h-80 w-full object-cover" />
      ) : (
        <MigrationMap state={state} />
      )}
      <div className="space-y-6 p-6 sm:p-10">
        {state.status === 'intro' && <Introduction onContinue={actions.onContinue} faqUrl={actions.faqUrl} />}
        {state.status === 'ready' && <Confirmation {...state} {...actions} title={title} />}
        {state.status === 'upgrading' && <Upgrading {...state} title={title} />}
        {state.status === 'success' && (
          <Success
            {...state}
            title={title}
            onSeeTransactions={actions.onSeeTransactions}
            actionPending={actions.actionPending}
          />
        )}
        {state.status === 'failure' && <Failure {...state} {...actions} title={title} />}
      </div>
    </Modal>
  );
}
